import Landing from "./Landing";
import { usePageSEO } from "@/hooks/usePageSEO";

const Index = () => {
  usePageSEO({ title: "BotSweep — Real-Time Bot Detection & Traffic Intelligence", path: "/", description: "Detect and block malicious bots in real-time. One script tag. AI-powered fingerprinting, behavioral analysis, and instant threat dashboard. Free tier available." });
  return <Landing />;
};

export default Index;
